import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CONTROLLER, METHOD } from '../constants/endpoint.constants';
import { ClientList } from '../interfaces/landing.interface';
import { CommonService } from './common/common.service';

@Injectable({
  providedIn: 'root',
})
export class LandingService extends CommonService {
  public clientList!: ClientList;

  constructor(private http: HttpClient) {
    super();
  }

  getClientList(): Observable<any> {
    return this.http
      .get<ClientList[]>(this.joinApiUrl([CONTROLLER.CLIENT, METHOD.ALL]))
  }
}
